import { Component, OnDestroy, OnInit } from '@angular/core';
import { Constants } from '../shared-api/common/constants';
import { MenuItem, SelectItem } from 'primeng/api';
import { Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AuthManagerService } from '../shared-api/auth/auth-manager.service';
import { BroadcastService } from '../core/services/broadcast.service';
import { OrganizationManagerService, ViewMode } from '../shared-api/organization/organization-manager.service';
import { TenantManagerService } from '../shared-api/tenant/tenant-manager.service';
import { Product } from '../shared-api/tenant/product.model';
import { OrganizationListItem } from '../shared-api/organization/organization-list-Item.model';
import { LocalStorageManagerService } from '../core/managers/local-storage-manager.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Organization } from '../shared-api/organization/organization.model';

@UntilDestroy()
@Component({
    selector: 'myapp-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit, OnDestroy
{
    // Constants
    Constants = Constants;

    // Member vars
    menuItems: MenuItem[];
    isMobileFormFactor = false;
    logoImage: string = undefined;
    previousLogoImage = this.logoImage;
    hideImage = false;
    applyFadeIn = false;
    showOrganizationSelector = false;
    organizations: SelectItem[];
    organization: OrganizationListItem;
    fullOrganization: Organization;
    // isChangingPassword = false;

    logoClass: string;
    logoImageUrl = Constants.MyAppLogoUrl;

    ViewMode = ViewMode;

    constructor(private router: Router,
                private organizationManager: OrganizationManagerService,
                public orgManager: OrganizationManagerService,
                private tenantManager: TenantManagerService,
                private broadcastService: BroadcastService,
                private localStorageManager: LocalStorageManagerService,
                private authManager: AuthManagerService,
                private deviceDetector: DeviceDetectorService) { }

    ngOnInit()
    {
        this.initializeHeader();

        this.broadcastService.windowResize.pipe(untilDestroyed(this)).subscribe(() => this.setLogoImage());
        this.isMobileFormFactor = this.deviceDetector.isMobile();
    }

    ngOnDestroy(): void
    {
    }

    onOrganizationChange(event: any)
    {
        this.organization = <OrganizationListItem>event.value;
        this.setOrganizationForGlobalAdmin();
    }

    onSignOut()
    {
        this.authManager.signOut();
        this.orgManager.switchingOrganizations();
        this.orgManager.viewMode = ViewMode.Album;
    }

    onToggleViewMode(): void
    {
        this.orgManager.viewMode = this.orgManager.viewMode === ViewMode.Album ? ViewMode.Folder : ViewMode.Album;
        this.broadcastService.viewModeChanged.next();

        this.router.navigate([ this.orgManager.viewMode === ViewMode.Album ? '/folder/0' : '/doc-center/0' ]);
    }

    private setOrganizationForGlobalAdmin()
    {
        this.authManager.signInWithRefreshToken(this.organization.Id)
            .subscribe(() =>
            {
                this.getOrganizationAndProduct();
            });
    }

    private getOrganizationAndProduct()
    {
        this.orgManager.switchingOrganizations();
        this.tenantManager.switchingOrganizations();
        this.orgManager.currentOrganization
            .subscribe(org =>
            {
                this.fullOrganization = org;
                this.tenantManager.currentProduct
                    .subscribe((product: Product) =>
                    {
                        this.localStorageManager.currentOrganization = org;
                        this.broadcastService.organizationChanged.next(org);

                        switch (product.Name.toLowerCase())
                        {
                            case 'myconnectedapp':
                                this.logoClass = 'my-connected-app';
                                this.logoImageUrl = Constants.MyConnectedAppLogoUrl;
                                break;
                            case 'myclubapp':
                                this.logoClass = 'my-club-app';
                                this.logoImageUrl = Constants.MyClubAppLogoUrl;
                                break;
                            case 'mycampapp':
                                this.logoClass = 'my-camp-app';
                                this.logoImageUrl = Constants.MyCampAppLogoUrl;
                                break;
                            default:
                                this.logoClass = 'my-unknown-app';
                                this.logoImageUrl = Constants.MyConnectedAppLogoUrl;
                        }

                        this.setLogoImage();
                    });
            });
    }

    private initializeHeader()
    {
        // Construct Menu
        this.menuItems = [
            {
                label: this.authManager.authenticatedUser.fullName,
                items: [
                    {
                        label: 'Change Password', command: (event) =>
                        {
                            this.router.navigate(['/account/changepassword', this.router.url]);
                        },
                    },
                ]
            },
        ];

        // Set proper logo
        this.setLogoImage();

        // Set proper layout
        this.isMobileFormFactor = this.deviceDetector.isMobile();

        if (!this.authManager.authenticatedUser.isGlobalAdmin)
        {
            this.getOrganizationAndProduct();
        }
    }

    private setLogoImage()
    {
        const width = window.innerWidth;

        if (width <= Constants.MinWidthForFullNavbar && width > Constants.MobileWidth)
        {
            this.swapImageIfNotSame(Constants.MyAppLogoUrl);
            return;
        }

        this.swapImageIfNotSame(this.logoImageUrl);
    }

    private swapImageIfNotSame(newImageUrl: string)
    {
        if (this.previousLogoImage !== newImageUrl)
        {
            // Hide the old image
            this.applyFadeIn = false;
            this.hideImage = true;

            // Change the image
            this.logoImage = newImageUrl;
            this.previousLogoImage = this.logoImage;

            // Fade it in
            setTimeout(() =>
            {
                this.hideImage = false;
                this.applyFadeIn = true;
            }, 10);
        }
    }

    onNavigateHome()
    {
        this.router.navigate([ '/folder', 0 ]);
    }
}
